var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.33333V0H11.6667V2.33333H13.4167C13.7388 2.33333 14 2.5945 14 2.91667V13.4167C14 13.7388 13.7388 14 13.4167 14L0 14V1.86176L7.21666 0.315332C8.30605 0.0818894 9.33333 0.912357 9.33333 2.02649V2.33333H10.5ZM9.33333 3.5V12.8333L12.8333 12.8333V11.0833H11.0833V9.91667H12.8333V8.75H11.0833V7.58333H12.8333V6.41667H11.0833V5.25H12.8333V3.5H9.33333ZM8.16667 12.8333V2.02649C8.16667 1.65511 7.82424 1.37829 7.46111 1.4561L1.16667 2.80491V12.8333H2.91667V10.5H6.41667V12.8333H8.16667ZM5.25 12.8333V11.6667H4.08333V12.8333H5.25ZM4.08333 4.66667H2.33333V3.5H4.08333V4.66667ZM7 4.66667H5.25V3.5H7V4.66667ZM4.08333 7H2.33333V5.83333H4.08333V7ZM7 7H5.25V5.83333H7V7ZM4.08333 9.33333H2.33333V8.16667H4.08333V9.33333ZM7 9.33333H5.25V8.16667H7V9.33333Z",
    fill: "#1DD4B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrock);
export default __webpack_public_path__ + "static/media/strock.8066cbd017c2567d533190f969c0faff.svg";
export { ForwardRef as ReactComponent };